//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

// @import components
import {PublicAppLayout} from 'app_components/layouts/public'
import BannerModule from 'app_components/modules/newsEvents/banner'
// @end

// @INFO Import Styles
import './../publicScreen.scss'
import ModularCarousel from 'app_components/modules/ModularCarousel/ModularCarousel'
import LandingFilter from 'app_components/modules/LandingFilter/LandingFilter'
import TestimoniesModulesLanding from 'app_components/modules/TestimoniesModulesLanding/TestimoniesModulesLanding'
import MoreViewedProgramsModule from 'app_components/modules/MoreViewedProgramsModule/MoreViewedProgramsModule'
import EducationalImpactLanding from 'app_components/modules/EducationalImpactLanding/EducationalImpactLanding'
import NewsEventsLanding from 'app_components/modules/NewsEventsLanding/NewsEventsLanding'
import useWindowWidth from 'app_hooks/useWindowWidth'

const MOVIL_BREAKPOINT = 760

// @ADD Component types
interface IPublicScreenLayoutProps {}

const PublicScreenLayout: React.FC<IPublicScreenLayoutProps> = (props) => {
  const { windowWidth } = useWindowWidth()
  const isMovil = windowWidth && windowWidth <= MOVIL_BREAKPOINT

  const { t } = useTranslation()

  return(
    <PublicAppLayout>
      <div className="public_screen-component">
        <section className="banner-section">
          <BannerModule />
        </section>
        {!isMovil && (
          <section>
            <ModularCarousel />
          </section>
        )}
        <section>
          <LandingFilter />
        </section>
        {isMovil && (
          <section>
            <ModularCarousel />
          </section>
        )}
        <section>
          <MoreViewedProgramsModule />
        </section>
        <section>
         <TestimoniesModulesLanding slug='home' />
        </section>
        <section>
          <EducationalImpactLanding slug='home' />
        </section>
        <section>
          <NewsEventsLanding/>
        </section>
      </div>
    </PublicAppLayout>
  )
}

export default PublicScreenLayout
